import {
  SliderComponentChild,
  SliderComponentChild2,
} from "./sliderComponent/SliderComponentChild";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Slider = ({ model = [] }) => {
  if (model.length > 0 && model[0].is_active)
    return (
      <>
        <div className="container d-lg-none">
          <Swiper
            className="mySwiper"
            loop={true}
            autoplay={
              model[0].auto_play
                ? {
                    delay: model[0].delay ?? 4000,
                    disableOnInteraction: false,
                  }
                : {}
            }
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            modules={model[0].auto_play ? [Navigation, Autoplay] : [Navigation]}
          >
            {model[0].items.map((item, index) => {
              return (
                <SwiperSlide key={`slider_${index}`}>
                  <SliderComponentChild2 item={item} />
                </SwiperSlide>
              );
            })}
            <div className="swiper-button-prev">
              <span aria-label="Previous">‹</span>
            </div>
            <div className="swiper-button-next">
              <span aria-label="Next">›</span>
            </div>
          </Swiper>
        </div>
        {/* اسلایدر بزرگ برای دسکتاپ */}
        <div className="home-big-slider d-none d-lg-block">
          <Swiper
            className="mySwiper"
            loop={true}
            autoplay={
              model[0].auto_play
                ? {
                    delay: model[0].delay ?? 4000,
                    disableOnInteraction: false,
                  }
                : {}
            }
            modules={model[0].auto_play ? [Autoplay] : []}
          >
            {model[0].items.map((item, index) => {
              return (
                <SwiperSlide key={`slider_${index + index}`}>
                  <SliderComponentChild item={item} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </>
    );
};

export default Slider;
